// Codekit -->
// @codekit-prepend "global/vars.js"
// @codekit-prepend "utilities/debounce.js"
// @codekit-prepend "utilities/loadIn.js"
// @codekit-prepend "utilities/ajax.js"
// @codekit-prepend "utilities/lazy.js"
// @codekit-prepend "utilities/hero.js"
// @codekit-prepend "components/menu.js"
// @codekit-prepend "components/number-animation.js"
// @codekit-prepend "components/header.js"
// @codekit-prepend "components/scroll-down.js"
// @codekit-append "global/resize.js"

// Menu
menu();

//Header
window.addEventListener("scroll", debounce(headerReveal));

//Example function pullin
// if (typeof pageTitleCtrls != "undefined" && pageTitleCtrls != null) {
//     pageTitles();
// }

//on ready
$(document).ready(function () {
    $body.rhLoadIn();

    if (typeof hero != "undefined" && hero != null) {
        heroSize();
    }

    // $('#ajaxContainer').rhLoadIn({
    //     ajax:true
    // });

    //images loaded
    // $(".bgImgLoad").imagesLoaded({ background: ".bgImgLoad" }, function () {
    //     $(".bgImgLoad").animate({ opacity: "1" }, 300);
    // });

    $(".imgLoad").imagesLoaded(function () {
        $(".imgLoad").animate({ opacity: "1" }, 300);
    });
}); // end doc ready
